import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, Button } from '@material-ui/core';

export default function AddQuesitonDialog({ open, handleClose, action }) {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <DialogContentText>آیا از اضافه کردن این سوال اطمینان دارید ؟</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={action} color="primary">
          تایید
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
